/* assets/kbs-discount-display.js
 * ------------------------------------------------------------
 * KBS Rabattcode-Anzeige (Okt 2026)
 *
 * Hat der Besucher einen Rabattcode (Mail-Link /discount/CODE → Shopify
 * legt ihn in cart.discount_codes + Cookie "discount_code"), holt dieses
 * Skript die Regel des Codes vom Cloudflare Worker "kbs-discount-info"
 * und zeigt sie an:
 *   - wegklickbare Leiste ganz oben (vor #header-group)
 *   - auf PDP und Produktkarten: neuer Preis + Streichpreis + "mit Code X",
 *     oder ein Hinweis "−10 € mit Code X ab 99 € Bestellwert"
 *
 * Datenquelle je Preis: Attribute am Container aus snippets/price.liquid
 * (data-kbs-base / -pre-off / -compare / -product / -collections). Gefilterte
 * Karten (sections/kbs-collection-filter.liquid) setzen dieselben Attribute.
 *
 * Regeln (wie im Shopify-Checkout):
 *   - Code und Vorbestellrabatt "-2%" kombinieren nicht → es zaehlt der hoehere.
 *   - Prozent-Code: Abzug abgerundet, wie Shopify.
 *   - Fixbetrag/Mindestwert sind in EUR angelegt → mit Shopify.currency.rate in
 *     die Marktwaehrung umgerechnet, wie Shopify im Warenkorb/Checkout.
 *   - Mindestbestellwert nicht erreicht → nur Hinweis, kein Streichpreis.
 * Ausfall/Timeout des Workers → es passiert einfach nichts.
 * Texte (21 Sprachen) und Konfiguration: snippets/kbs-discount-display.liquid
 */
(() => {
  if (window.KBSDiscountDisplay) return;
  const cfgEl = document.getElementById('kbs-dd-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const t = cfg.t || {};
  const TIMEOUT = 2500;
  const CACHE_MS = 300000;

  /* ---------- aktiver Code ---------- */
  const cookie = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
  let code = (cfg.codes || '').split(',').map((c) => c.trim()).filter(Boolean)[0] || '';
  if (!code && cookie) { try { code = decodeURIComponent(cookie).trim(); } catch (e) { code = ''; } }
  if (!code || !/^[A-Za-z0-9_-]{2,64}$/.test(code)) return;
  const CODE = code.toUpperCase();

  /* ---------- Warenkorb nachziehen ----------
   * Shopify verliert den Code im Warenkorb, wenn ein neuer Warenkorb entsteht
   * (Warenkorb geleert, abgelaufen, nach einem Checkout), das Cookie
   * "discount_code" bleibt aber. Dann wuerde die Seite Code-Preise zeigen, die
   * der Warenkorb nicht hat → Code still wieder auf den Warenkorb legen.
   * Pruefung ueber /cart.js (enthaelt auch noch nicht anwendbare Codes, z. B. bei
   * leerem Warenkorb – Liquid cart.discount_codes nicht). KEIN cart:update-Event:
   * das oeffnet den Warenkorb-Drawer. Liegen Artikel im Warenkorb, einmal neu laden,
   * damit der Drawer den Rabatt zeigt (Sperre je Code in sessionStorage). */
  /* KBS 10/2026 (F-024): Code nur noch nach gueltiger Worker-Regel (siehe run) wieder
   * anlegen, hoechstens 1x je Code und Browser und nur in den ersten 7 Tagen nach dem
   * ersten Kontakt. Lag der Code schon in einem Warenkorb mit Artikeln (z. B. vor einer
   * Bestellung), wird er nicht erneut angelegt. Liefert true, wenn der Code im Warenkorb liegt. */
  const FIRST_KEY = 'kbs-dd-first:' + CODE;
  const APPLIED_KEY = 'kbs-dd-applied:' + CODE;
  const MAX_AGE_MS = 7 * 864e5;
  const lsGet = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  if (!lsGet(FIRST_KEY)) lsSet(FIRST_KEY, String(Date.now()));
  function dropCookie() { document.cookie = 'discount_code=; Max-Age=0; path=/'; }

  function syncCart() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart) return false;
        const has = (cart.discount_codes || []).some((d) => String(d.code).toUpperCase() === CODE);
        if (has) {
          if (cart.item_count) lsSet(APPLIED_KEY, '1');
          return true;
        }
        const first = parseInt(lsGet(FIRST_KEY), 10) || Date.now();
        if (lsGet(APPLIED_KEY) === '1' || Date.now() - first > MAX_AGE_MS) {
          dropCookie(); // schon einmal genutzt oder zu alt → nicht mehr anlegen, auch nicht durch Shopify
          return false;
        }
        lsSet(APPLIED_KEY, '1');
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        }).then((r) => (r.ok ? r.json() : null)).then((upd) => {
          if (!upd) return false;
          if (upd.item_count) {
            const key = 'kbs-dd-reload:' + CODE;
            let done = false;
            try { done = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) { done = true; }
            if (!done) location.reload();
          }
          return true;
        });
      })
      .catch(() => false);
  }

  /* ---------- Geldformat aus Shopify-Muster ----------
   * cfg.sample = 1234567800 Cent | money, also "12.345.678,00 €" oder bei Waehrungen
   * ohne Nachkommastellen (HUF, CZK …) "12.345.678 Ft". Daraus Tausender-/
   * Dezimaltrenner und Waehrungszeichen uebernehmen, genau wie Shopify formatiert. */
  const RE = /12(\D?)345\1?678(?:(\D)(\d\d))?/;
  const fmtPlain = String(cfg.sample || '');
  const fmtCur = String(cfg.sampleCur || cfg.sample || '');
  // Preise im Theme koennen mit Waehrungscode stehen (Theme-Einstellung "Waehrungscode
  // anzeigen", z. B. "59.500 HUF") → dasselbe Format wie der vorhandene Preis verwenden.
  function money(cents, withCur) {
    const sample = withCur ? fmtCur : fmtPlain;
    const m = sample.match(RE);
    const neg = cents < 0;
    const v = Math.abs(Math.round(cents));
    if (!m) {
      try { return (neg ? '−' : '') + (v / 100).toLocaleString(undefined, { style: 'currency', currency: cfg.currency || 'EUR' }); }
      catch (e) { return (neg ? '−' : '') + (v / 100).toFixed(2); }
    }
    const hasDec = m[2] != null;
    const units = hasDec ? Math.floor(v / 100) : Math.round(v / 100);
    let out = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, m[1] || '');
    if (hasDec) out += m[2] + String(v % 100).padStart(2, '0');
    return (neg ? '−' : '') + sample.replace(m[0], out);
  }
  function pct(n) {
    const m = fmtPlain.match(RE);
    const s = Number.isInteger(n) ? String(n) : String(n).replace('.', m && m[2] === ',' ? ',' : '.');
    return s + ' %';
  }
  const fill = (s, map) => String(s || '').replace(/\{(\w+)\}/g, (_, k) => (map[k] != null ? map[k] : ''));

  /* ---------- Regel vom Worker (mit Session-Cache) ---------- */
  async function getRule() {
    const key = 'kbs-dd:' + CODE;
    try {
      const hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && Date.now() - hit.t < CACHE_MS) return hit.v;
    } catch (e) { /* privater Modus */ }
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), TIMEOUT);
    try {
      const res = await fetch(cfg.worker + '?code=' + encodeURIComponent(code), { signal: ctrl.signal });
      if (!res.ok) return null;
      const v = await res.json();
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v })); } catch (e) {}
      return v;
    } catch (e) {
      return null;
    } finally {
      clearTimeout(timer);
    }
  }

  function run(rule) {
    // Der Worker liefert bei eigenen Stoerungen {ok:false}; ungueltige oder abgelaufene Codes kommen als {ok:true, active:false}.
    if (!rule || !rule.ok) return; // Stoerung → nichts tun, Cookie bleibt
    const expired = !!(rule.endsAt && Date.parse(rule.endsAt) < Date.now());
    if (expired) dropCookie(); // abgelaufen → Cookie weg
    if (expired || !rule.active) return; // inaktiv oder noch geplant → nichts anzeigen, nichts anlegen
    syncCart().then((inCart) => { if (inCart) show(rule); });
  }

  function show(rule) {
    // Fremdwaehrung: Shopify rechnet Fixbetraege und Mindestbestellwerte mit dem
    // Markt-Kurs um (Shopify.currency.rate, bei KBS feste Kurse; geprueft: DKK 8,0 →
    // 5 € = 40,00 kr., CHF 1,0 → 5 € = 5,00 CHF). Gleiche Rechnung hier.
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    const conv = (c) => Math.round(c * rate);
    const fixedOk = rule.type !== 'fixed' || !rule.currency || rule.currency === 'EUR';
    const minOk = true;
    const fixedVal = rule.type === 'fixed' && rule.value ? conv(rule.value) : 0;
    const minVal = rule.minSubtotal ? conv(rule.minSubtotal) : 0;

    let offer = '';
    if (rule.type === 'percentage' && rule.value) offer = '−' + pct(rule.value);
    else if (rule.type === 'fixed' && fixedVal && fixedOk) offer = '−' + money(fixedVal);
    else if (rule.type === 'shipping') offer = t.ship || '';
    const minTxt = rule.minSubtotal && minOk ? fill(t.min, { min: money(minVal) }) : '';
    const selTxt = rule.scope && rule.scope !== 'all' ? t.sel || '' : '';

    /* ----- Leiste unter dem Header ----- */
    let closed = '';
    try { closed = localStorage.getItem('kbs-dd-closed') || ''; } catch (e) {}
    if (closed !== CODE && !document.querySelector('.kbs-dd-bar')) {
      const bar = document.createElement('div');
      bar.className = 'kbs-dd-bar';
      bar.setAttribute('role', 'status');
      const txt = document.createElement('span');
      txt.className = 'kbs-dd-bar__text';
      const parts = [fill(t.active, { code })];
      let detail = [offer, selTxt, minTxt].filter(Boolean).join(' ');
      txt.textContent = parts[0] + (detail ? ': ' + detail : '');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kbs-dd-bar__close';
      btn.setAttribute('aria-label', t.close || 'Close');
      btn.innerHTML = '<svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
      btn.addEventListener('click', () => {
        bar.remove();
        try { localStorage.setItem('kbs-dd-closed', CODE); } catch (e) {}
      });
      bar.appendChild(txt);
      bar.appendChild(btn);
      const header = document.getElementById('header-group');
      if (header) header.insertAdjacentElement('beforebegin', bar);
      else document.body.prepend(bar);
    }

    /* ----- Preise ----- */
    if (rule.type !== 'percentage' && rule.type !== 'fixed') return;
    if (!fixedOk) return;
    const cols = (rule.collections || []).map(String);
    const prods = (rule.products || []).map(String);

    function eligible(ds) {
      if (rule.scope === 'collections') {
        const own = String(ds.kbsCollections || '').split(',');
        return own.some((c) => cols.indexOf(c) !== -1);
      }
      if (rule.scope === 'products') return prods.indexOf(String(ds.kbsProduct || '')) !== -1;
      return true;
    }

    // Code-Zeile UNTER den Preis: <product-price> ist eine Flex-Zeile (Preis | inkl. MwSt.),
    // daher hinter das ganze product-price-Element setzen, nicht in die Zeile.
    function line(pc, text, cls) {
      if (pc.__kbsLine) pc.__kbsLine.remove();
      const p = document.createElement('p');
      p.className = 'kbs-dd-line' + (cls ? ' ' + cls : '');
      p.textContent = text;
      const anchor = pc.closest('product-price') || pc;
      anchor.insertAdjacentElement('afterend', p);
      pc.__kbsLine = p;
    }

    function decoratePrice(pc) {
      if (pc.hasAttribute('data-kbs-dd')) return;
      pc.setAttribute('data-kbs-dd', '');
      const ds = pc.dataset;
      const base = parseInt(ds.kbsBase, 10);
      if (!base || !eligible(ds)) return;
      const preOff = parseInt(ds.kbsPreOff, 10) || 0;
      const compare = parseInt(ds.kbsCompare, 10) || 0;
      const withTxt = fill(t.with, { code });

      // Mindestbestellwert, den dieses Produkt allein nicht erreicht → nur Hinweis
      if (minVal && (!minOk || base < minVal)) {
        if (offer && minTxt) line(pc, [offer, withTxt, minTxt].join(' '), 'kbs-dd-line--hint');
        return;
      }

      let off = 0;
      if (rule.type === 'percentage') off = Math.floor((base * rule.value) / 100);
      else off = Math.min(fixedVal, base);
      // Kein Aufaddieren: der automatische Vorbestellrabatt "-2%" ist mit nichts kombinierbar,
      // Shopify gibt dann nur den hoeheren der beiden (im Checkout getestet).
      if (off <= preOff) return; // Vorbestellrabatt ist mindestens gleich gut → blauer Preis bleibt

      const priceEl = pc.querySelector('.price');
      if (!priceEl) return;
      const withCur = !!cfg.currency && pc.textContent.indexOf(cfg.currency) !== -1;
      priceEl.textContent = money(base - off, withCur);
      priceEl.classList.add('price--on-sale', 'kbs-dd-price');
      priceEl.classList.remove('price--preorder');

      const was = Math.max(compare, base);
      let cmp = pc.querySelector('.compare-at-price');
      if (!cmp) {
        cmp = document.createElement('span');
        cmp.className = 'compare-at-price';
        const group = priceEl.closest('[role="group"]') || priceEl;
        group.insertAdjacentElement('afterend', cmp);
      }
      cmp.textContent = money(was, withCur);
      line(pc, withTxt);
    }

    function decorate(root) {
      const scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('[data-kbs-price]')) decoratePrice(scope);
      scope.querySelectorAll('[data-kbs-price]').forEach(decoratePrice);
    }
    window.KBSDiscountDisplay.decorate = decorate;
    decorate(document);

    new MutationObserver((list) => {
      for (const rec of list) {
        rec.addedNodes.forEach((n) => { if (n.nodeType === 1) decorate(n); });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.KBSDiscountDisplay = { code: CODE, decorate: () => {} };
  getRule().then(run).catch(() => {});
})();